let myDefineRouter=[
  {myRoute:"editDoctor",name:'医生管理',},
  {myRoute:"recipeDetails",name:'处方订单管理',},
  {myRoute:"userDetails",name:'用户管理',},
  {myRoute:"addStaff",name:'人员管理',},
  {myRoute:"visitDetails",name:'就诊订单管理',},
]
export default myDefineRouter;



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/myDefineRouter.js